import axios, { AxiosResponse } from 'axios'; //npm install axios --save //npm install --save es6-promise For IE
import { Constant } from '@/helpers/constant';
import { Rest, RestHeader } from '@/helpers/rest';

import router from '@/router';

class NotificationService {

  axios;
  constructor() {
    this.axios = axios.create({});
  }

  
  public getNotifications(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/getNotificationDataByUser', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public updateOrCreateToken(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/updateOrCreateToken', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }

  public generateToken(data): Promise<AxiosResponse<any>> {
    return this.axios.post(Constant.SERVER_URL + 'api/chattoken', data,
      { headers: Rest.getHeaders(RestHeader.APPLICATION_JSON_WITH_BEARER_TOKEN) }).then(ag => {
        return ag;
      }).catch(err => {
        if (err == "Error: Request failed with status code 401") {
          alert("HRDF Unauthorized");
          localStorage.clear();
          router.push('/');
        }
        else if (err == "Error: Request failed with status code 500") {
          return err;
        }
        else if (err == "Error: Request failed with status code 400") {
           alert("Bad Request!");
          return err;
        } else if (err == "Error: Request failed with status code 404") {
          alert("Page Not Found!");
          localStorage.clear();
          router.push('/');
        }
        return err;
        // Manage the state of the application if the request
        // has failed
      });
  }
}

export default new NotificationService();
